<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.servico"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleEdit(item.id)"
                authorize="edit-ambulatorio-servico"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="handleDestroy(item)"
                authorize="destroy-ambulatorio-servico"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            servico: this.getConectaSusRepository('ambulatorio.servico'),
        }
    },
    data: () => ({
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                name: 'servico.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'tipo',
                label: 'Tipo',
                name: 'tipo.nome',
                searchable: true,
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
            },
        ],
    }),
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'ambulatorio-servico-edit', params: { id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.servico.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o serviço?', destroy)
        },
    },
    mixins: [error, repository],
}
</script>